import {Home} from '../../Services/HomeService';
import {Survey} from '../../Services/SurveyService';
import {Article} from '../../Services/ArticleService';
import {Page} from '../../Models';

export const INITIALISE = 'home/INITIALISE';
export const SET_PAGE = 'home/SET_PAGE';
export const SET_CATEGORY = 'home/SET_CATEGORY';
export const SET_CATEGORIES = 'home/SET_CATEGORIES';
export const SET_AUTHOR = 'home/SET_AUTHOR';
export const SET_AUTHORS = 'home/SET_AUTHORS';
export const SET_SEARCH = 'home/SET_SEARCH';
export const SET_ARTICLES = 'home/SET_ARTICLES';
export const SET_LOADING = 'home/SET_LOADING';
export const SET_PRIORITY_MODULES = 'home/SET_PRIORITY_MODULES';

interface UpdateAction {
  type: typeof INITIALISE;
  payload: Home;
}

interface SetPageAction {
  type: typeof SET_PAGE;
  payload: number;
}

interface SetCategoryAction {
  type: typeof SET_CATEGORY;
  payload: string;
}

interface SetCategoriesAction {
  type: typeof SET_CATEGORIES;
  payload: string[];
}

interface SetAuthorAction {
  type: typeof SET_AUTHOR;
  payload: {
    id: number;
    name: string;
  };
}

interface SetAuthorsAction {
  type: typeof SET_AUTHORS;
  payload: Record<number, string>;
}

interface SetSearchAction {
  type: typeof SET_SEARCH;
  payload: string;
}

interface SetArticlesAction {
  type: typeof SET_ARTICLES;
  payload: Page<Article>;
}

interface SetLoadingAction {
  type: typeof SET_LOADING;
  payload: boolean;
}

interface SetPriorityModulesAction {
  type: typeof SET_PRIORITY_MODULES;
  payload: string[];
}

export interface HomeState {
  survey?: Survey;
  recentArticles: Page<Article>;
  categories: string[];
  categoryUses: Record<string, number>;
  currentCategory: string;
  currentAuthor: number;
  currentSearch: string;
  currentPage: number;
  authorName: string;
  authors: Record<number, string>;
  articles: Page<Article>;
  loading: boolean;
  priorityModules: string[];
}

export type HomeActionTypes =
  UpdateAction |
  SetPageAction |
  SetCategoryAction |
  SetCategoriesAction |
  SetAuthorAction |
  SetAuthorsAction |
  SetSearchAction |
  SetArticlesAction |
  SetLoadingAction |
  SetPriorityModulesAction;
